import { Injectable } from '@angular/core';
import { HttpMethodType } from '@app/app.constant';
import {
  IGetMyNotificationsRequest,
  IUserNotificationListResponse
} from '@app/models/notifications/user-notification.model';
import { HttpCallService } from '@core/services/http-call.service';
import { Observable } from 'rxjs';

const HttpServiceMethods = {
  GetMyNotifications: 'UserNotification/GetMyNotifications',
  GetMyUnseenCount: 'UserNotification/GetMyUnseenCount',
  MarkAllSeen: 'UserNotification/MarkAllSeen'
};

@Injectable({
  providedIn: 'root'
})
export class UserNotificationService {

  constructor(private httpService: HttpCallService) { }

  public getMyNotifications(request: IGetMyNotificationsRequest): Observable<IUserNotificationListResponse> {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.GetMyNotifications,
      request
    );
  }

  public getMyUnseenCount(): Observable<number> {
    return this.httpService.callService(
      HttpMethodType.GET,
      HttpServiceMethods.GetMyUnseenCount
    );
  }

  public markAllSeen(): Observable<boolean> {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.MarkAllSeen,
      {}
    );
  }
}
